import * as THREE from 'three'
import Experience from '../Experience'

export default class Lights {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.setLights()
    }

    setLights() {
        this.directionalLight = new THREE.DirectionalLight('#ffffff', 1)
        this.ambientLight = new THREE.AmbientLight('#ffffff', 0.5)
        this.directionalLight.position.set(1, 1, 0)
        this.scene.add(this.directionalLight)
        this.scene.add(this.ambientLight)
    }
}